__webpack_require__.p = "/journal-app/";